import GroupedReportView from '../../../components/reports/GroupedReportView';

export function IncomeStatementReport() {
  return (
    <GroupedReportView
      title="Income Statement"
      description="Revenue less expenses for a date range, yielding net surplus or deficit."
      endpoint="/reports/consolidated/income-statement"
      filters={['dateRange']}
      supportsComparative
      xlsx
    />
  );
}
